import styled from 'styled-components';
import theme from 'theme/theme';
import Button from '../Button/Button';

const LargeIconButton = styled(Button)`
  display: flex;
  align-items: center;
  font-size: ${theme.fontSizes.default};
  svg {
    top: 0;
    margin-left: 0.2rem;
  }
`;
LargeIconButton.defaultProps = {
  variant: 'ghost',
};

export default LargeIconButton;
